import React from 'react';
import IconButton from '@mui/material/IconButton';
// eslint-disable-next-line no-unused-vars
import {GridColDef} from '@mui/x-data-grid-pro';
// eslint-disable-next-line no-unused-vars
import {BrickContext} from 'olympe';
import {EventDetailsPopup} from '../section_risk/CrisisEventDetails/EventDetailsPopup.jsx';
import {
    AttachMoney,
    DescriptionOutlined,
    LocationOnOutlined,
    PersonOutline,
    Search,
    Anchor,
    ReportProblemOutlined,
    WbCloudyOutlined,
} from '@mui/icons-material';

import {
    List,
    ListItem,
    ListItemText,
    Tooltip,
} from '@mui/material';


export const getRowId = (row) => {
    return row['recordSequence'] + row['plantId'] + row['materialId'] + row['spendCategory1'] +
        row['specificationCode'] + (Array.isArray(row['mainVendor']) && row['mainVendor'][0]?.id || '') + row['vendorSiteNumber'];
};

/**
 * Commons data columns to the RCTable and AddMaterialsTable
 * @param {BrickContext} $
 * @return {Array<GridColDef>}
 */
export const materialsDataColumns = ($) => {


    return [
        {
            field: 'zone',
            headerName: 'Zone',
            minWidth: 150,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        sx={{marginLeft: '-0.3vw'}}
                        primary={params.row?.zone}
                    />
                );
            },
        },
        {
            field: 'market',
            headerName: 'Market',
            minWidth: 150,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                   
                    <ListItemText
                        primary={params.row?.market}
                    />
                );
            },
        },
        {
            field: 'plant',
            headerName: 'Plant',
            minWidth: 200,
            resizable: true,
            pinnable: false,
            valueGetter: (params) =>
                `${params.row?.plantId || ''} - ${params.row?.plantDescription || ''
                }`,

            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row.plantId}
                        secondary={params.row?.plantDescription}
                    />
                );
            },
        },
        {
            field: 'material',
            headerName: 'Material',
            minWidth: 350,
            resizable: true,
            pinnable: false,

            valueGetter: (params) =>
                `${params.row?.materialId || ''} - ${params.row?.materialDescription || ''
                }`,

            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={parseInt(params.row.materialId, 10)}
                        secondary={params.row?.materialDescription}
                    />
                );
            },
        },
        {
            field: 'spendCategory1',
            headerName: 'Spend Cat L1',
            minWidth: 200,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.spendCategory1}
                    />
                );
            },
        },
        {
            field: 'spendCategory2',
            headerName: 'Spend Cat L2',
            minWidth: 200,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.spendCategory2}
                    />
                );
            },
        },
        {
            field: 'spendCategory3',
            headerName: 'Spend Cat L3',
            minWidth: 200,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.spendCategory3}
                    />
                );
            },
        },
        {
            field: 'specs',
            headerName: 'Specification',
            minWidth: 350,
            resizable: true,
            pinnable: false,
            

            valueGetter: (params) =>
                `${params.row.specificationCode || ''} - ${params.row.specificationDescription || ''
                }`,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.specificationCode}
                        secondary={params.row?.specificationDescription}
                    />
                );
            },
        },
        {
            field: 'vendor',
            headerName: 'Main Vendor',
            minWidth: 350,
            resizable: true,
            pinnable: false,

            valueGetter: (params) =>
                params.row.mainVendor && params.row?.mainVendor?.[0]
                    ? `${params.row.mainVendor[0]['id']} - ${params.row.mainVendor[0]['description']}`
                    : '',
            renderCell: (params) => (
                <List dense={true}>
                    {params.row.mainVendor.map((vendor) => {
                        return (
                            <ListItem
                                key={vendor.id + vendor.description}
                                style={{paddingTop: '1px'}}
                            >
                                <ListItemText
                                    primary={vendor?.id}
                                    secondary={vendor?.description}
                                />
                            </ListItem>
                        );
                    })}
                </List>
            ),
        },
        {
            field: 'vendorSite',
            headerName: 'Vendor Site',
            minWidth: 350,
            resizable: true,
            pinnable: false,

            valueGetter: (params) =>
                `${params.row?.vendorSiteNumber || ''} - ${params.row?.vendorSiteDescription || ''
                }`,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={parseInt(params.row.vendorSiteNumber, 10)}
                        secondary={params.row?.vendorSiteDescription}
                    />
                );
            },
        },
        {
            field: 'vendorSiteCity',
            headerName: 'Vendor Site City',
            minWidth: 130,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.vendorSiteCity}
                    />
                );
            },
        },
        {
            field: 'vendorSiteCountry',
            headerName: 'Vendor Site Country',
            minWidth: 130,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.vendorSiteCountry}
                    />
                );
            },
        },
        {
            field: 'financialRating',
            headerName: 'Financial Rating',
            minWidth: 200,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.financialRating}
                    />
                );
            },
        },
        {
            field: 'reasonCode',
            headerName: 'BCP Status',
            minWidth: 300,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.reasonCode}
                    />
                );
            },
        },
        {
            field: 'nnsStatus',
            headerName: 'NNS',
            minWidth: 75,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.nnsStatus}
                    />
                );
            },
        },
        {
            field: 'stock',
            headerName: 'Stock',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.stock}
                    />
                );
            },
        },
        {
            field: 'unit',
            headerName: 'Stock UoM',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.unit}
                    />
                );
            },
        },
        {
            field: 'stockCover',
            headerName: 'Stock Cover (days)',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.stockCover}
                    />
                );
            },
        },
        {
            field: 'bias1',
            headerName: 'Bias Previous Month (%)',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null
                    ? `${Math.floor(params.value)}`
                    : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.bias1}
                    />
                );
            },
        },
        {
            field: 'bias2',
            headerName: 'Bias Previous 2 Months (%)',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null
                    ? `${Math.floor(params.value)}`
                    : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.bias2}
                    />
                );
            },
        },
        {
            field: 'bias3',
            headerName: 'Bias Previous 3 Months (%)',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null
                    ? `${Math.floor(params.value)}`
                    : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.bias3}
                    />
                );
            },
        },
        {
            field: 'vesScore',
            headerName: 'VES Score (%)',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null
                    ? `${Math.floor(params.value)}`
                    : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.vesScore}
                    />
                );
            },
        },
        {
            field: 'PERFORMANCE_LEVEL',
            headerName: 'VSI Score (%)',
            minWidth: 120,
            resizable: true,
            pinnable: false,

            valueFormatter: (params) => {
                return params.value !== null
                    ? `${Math.floor(params.value)}`
                    : '-';
            },
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.PERFORMANCE_LEVEL}
                    />
                );
            },
        },
        {
            field: 'psName',
            headerName: 'PS Name',
            minWidth: 150,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.psName}
                    />
                );
            },
        },
        {
            field: 'pmName',
            headerName: 'PM Name',
            minWidth: 150,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.pmName}
                    />
                );
            },
        },
        {
            field: 'tastyClassification',
            headerName: 'Tasty Classification',
            minWidth: 150,
            resizable: true,
            pinnable: false,
            renderCell: (params) => {
                return (
                    <ListItemText
                        primary={params.row?.tastyClassification}
                    />
                );
            },
        }
    ];
};

/**
 * Risk level columns, specific to the RCTable
 *
 * @return {Array<GridColDef>}
 */
export const riskLevelColumns = () => {
    // eslint-disable-next-line consistent-return
    const riskBubbleBgColor = (risk) => {
        if (risk === 'Low') {
            return '#64A80A';
        } else if (risk === 'Medium') {
            return '#F19100';
        } else if (risk === 'High') {
            return '#D00032';
        }
    };

    return [
        {
            field: 'geoRiskLevel',
            headerName: 'Geo Risk',
            width: 15,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip title={'Geo Risk Level'}>
                    <IconButton
                        aria-label="Risk Geo"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <LocationOnOutlined/>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: (params) => (
                <div
                    className={'rc-risk-table-risk-bubble'}
                    style={
                        params.value
                            ? {
                                backgroundColor: riskBubbleBgColor(
                                    params.value
                                ),
                            }
                            : {}
                    }
                >
                    {params.value ? '' : '-'}
                </div>
            ),
        },
        {
            field: 'financialRiskLevel',
            headerName: 'Financial Risk',
            width: 15,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip title={'Financial Risk Level'}>
                    <IconButton
                        aria-label="Risk Financial"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <AttachMoney/>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: (params) => (
                <div
                    className={'rc-risk-table-risk-bubble'}
                    style={
                        params.value
                            ? {
                                backgroundColor: riskBubbleBgColor(
                                    params.value
                                ),
                            }
                            : {}
                    }
                >
                    {params.value ? '' : '-'}
                </div>
            ),
        },
        {
            field: 'sourcingFlexibilityRiskLevel',
            headerName: 'Sourcing Flexibility Risk',
            width: 15,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip title={'Sourcing Flexibility Risk Level'}>
                    <IconButton
                        aria-label="Risk SourcingFlex"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <Search/>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: (params) => (
                <div
                    className={'rc-risk-table-risk-bubble'}
                    style={
                        params.value
                            ? {
                                backgroundColor: riskBubbleBgColor(
                                    params.value
                                ),
                            }
                            : {}
                    }
                >
                    {params.value ? '' : '-'}
                </div>
            ),
        },
        {
            field: 'supplierOTIFRiskLevel',
            headerName: 'Supplier OTIF Risk',
            width: 15,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip title={'Supplier OTIF Risk Level'}>
                    <IconButton
                        aria-label="Risk SupplierOTIF"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <PersonOutline/>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: (params) => (
                <div
                    className={'rc-risk-table-risk-bubble'}
                    style={
                        params.value
                            ? {
                                backgroundColor: riskBubbleBgColor(
                                    params.value
                                ),
                            }
                            : {}
                    }
                >
                    {params.value ? '' : '-'}
                </div>
            ),
        },
        {
            field: 'planningRiskLevel',
            headerName: 'Planning Risk',
            width: 15,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip title={'Planning Risk Level'}>
                    <IconButton
                        aria-label="Risk Planning"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <DescriptionOutlined/>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: (params) => (
                <div
                    className={'rc-risk-table-risk-bubble'}
                    style={
                        params.value
                            ? {
                                backgroundColor: riskBubbleBgColor(
                                    params.value
                                ),
                            }
                            : {}
                    }
                >
                    {params.value ? '' : '-'}
                </div>
            ),
        },
        {
            field: 'RISK_LEVEL',
            headerName: 'Quality Risk',
            width: 15,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip title={'Quality Risk Level'}>
                    <IconButton
                        aria-label="Risk Quality"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <div style={{
                            fontSize: 20,
                            fontFamily: 'sans-serif',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            Q
                        </div>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: (params) => (
                <div
                    className={'rc-risk-table-risk-bubble'}
                    style={
                        params.value
                            ? {
                                backgroundColor: riskBubbleBgColor(
                                    params.value
                                ),
                            }
                            : {}
                    }
                >
                    {params.value ? '' : '-'}
                </div>
            ),
        },
    ];
};

export const crisisRiskLevelColumns = ($) => {

    return [
        {
            field: 'resExtremeWeatherRiskLevel',
            headerName: 'Extrem Weather',
            maxWidth: 20,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,
            align: 'center',

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip
                    title={'Extreme weather: Highlighting extreme weather & highlight potential vendor sites impacted'}>
                    <IconButton
                        aria-label="Extrem Weather"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <WbCloudyOutlined/>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: renderBubbleCell($)
        },
        {
            field: 'resPortCongestionRiskLevel',
            headerName: 'Port Congestion',
            width: 20,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,
            alignItems: 'center',
            align: 'center',

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip title={'Port congestion: Indicate port clousures or heavy traffic (Que) in ports'}>
                    <IconButton
                        aria-label="Port congestion"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <Anchor/>
                    </IconButton>
                </Tooltip>
            ),
            renderCell: renderBubbleCell($)
        },
        {
            field: 'resQualityRiskLevel',
            headerName: 'Quality',
            width: 20,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip
                    title={'Quality: Highlight potential food fraud/degradation issues or changes in quality standard'}>
                    <IconButton
                        aria-label="Quality risk"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <div style={{
                            fontSize: 20,
                            fontFamily: 'sans-serif',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            Q
                        </div>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: renderBubbleCell($)
        },
        {
            field: 'resGeopoliticalRiskLevel',
            headerName: 'Geopolitical situation',
            width: 20,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (
                <Tooltip
                    title={'Geopolitical situation: Highlight border control issues, changes of policies that could impact supply chain of goods'}>
                    <IconButton
                        aria-label="Geopolitical situation"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <LocationOnOutlined/>
                    </IconButton>
                </Tooltip>
            ),
            renderCell: renderBubbleCell($)
        },
        {
            field: 'resOthersRiskLevel',
            headerName: 'Others',
            width: 20,
            headerAlign: 'center',
            sortable: false,
            resizable: false,
            disableColumnMenu: true,

            valueFormatter: (params) => {
                return params.value !== null ? `${params.value}` : '-';
            },

            renderHeader: () => (

                <Tooltip title={'Other crisis '}>
                    <IconButton
                        aria-label="Other crisis"
                        style={{
                            width: '100%',
                            verticalAlign: 'middle',
                            color: '#676665',
                        }}
                        size="large"
                    >
                        <ReportProblemOutlined/>
                    </IconButton>
                </Tooltip>
            ),

            renderCell: renderBubbleCell($)
        }
    ];
};
// Function to handle cell content rendering and prevent click propagation for PCT columns (second panel)
const renderBubbleCell = ($) => {
    return (params) => {
        // Handle click events to stop propagation
        const handleClick = (event) => {
            event.stopPropagation();  // Stops the event from bubbling *up* to the grid's row click handler
        };

        return (
            <>
                {params.value ? (
                    // Wrap BubbleWithInfo to control the click behavior
                    <div onClick={handleClick}>
                        <EventDetailsPopup ctx={$}  gridParams={params}>
                        </EventDetailsPopup>
                    </div>
                ) : (
                    '-'  // Display a placeholder if there's no value
                )}
            </>
        );
    };
};
